import { BaseForRestoreVMPlanHelper } from 'wizards/helpers/bases/base-for-restore-vm-plan-helper';
import { WizardHelpersSettings } from 'wizards/helpers/bases/base-for-steps-helper';

export class RestoreHyperVPlanFromStepsHelpers extends BaseForRestoreVMPlanHelper {
  protected static setSpecificStepsData(newPlan: any, settings: WizardHelpersSettings): void {
    // Here specific data
  }
}
